/* Wrist Pinnacle current Colorway media map — verified Shopify variant-media associations, 2026-09-02. */
window.WristPinnacleCurrentColorwayMedia = {
  version: '2026-09-13.vale-cyan.1',
  mediaByModel: {
    'facet-01': {
      'Onyx / Ice': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/bqEoLnBcbQFehVcs.png?v=1787758107',
      'Slate / Charcoal': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/MSbPcHOXGKEsCfFP.png?v=1787758107',
      'Gold / Ivory': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/fMmGqoetntwbzuaC.png?v=1787758107',
      'Rose / Midnight': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/WulAkEVqFMUQUOpC.png?v=1787758108',
      'Rose / Blush': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/EdqRlENvAFIFluHe.png?v=1787770506'
    },
    'atria-02': {
      'Steel / Graphite': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/GlAOFPrRMbxcwsGZ.png?v=1787758156',
      'Rose / Ice': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/vkKQQnHdbuUeddso.png?v=1787758156',
      'Steel / Graphite / Gold / Green': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/WjqxXiybACpCvYPn.png?v=1787741494',
      'Rose / Green Radial': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/beeVsOWqSdgSoEuC.png?v=1787741494'
    },
    'vale-03': {
      'Steel / Green': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/QQuGExjoBdyrHmCR.png?v=1787874913',
      'Steel / Forest Relief': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/YiPQVTdjTHrhlauR.png?v=1787741535',
      'Steel / Cyan': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/wp-vale-cyan-front-logo-v1.png?v=1789282431'
    },
    'meridian-04': {
      'Gold / Black': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/whYClzzkvQvXVgDO.png?v=1787948389',
      'Steel / Green': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/FmIxXQJXCLDczVWT.png?v=1787758240',
      'Steel / Teal': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/bVDvlIWVEqtfyPwP.png?v=1787758239',
      'Steel / Black 24': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/wp-meridian-04-black24-front-crown-v1.png?v=1789255879'
    },
    'meridian-05': {
      'Steel / Blue': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/SGBVKkvCdrDKXrMN.png?v=1787948398',
      'Gold / Black': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/dinfasrBoBECCVXM.png?v=1787758275',
      'Rose / Black': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/zkyCeWrAmGuWmOfs.png?v=1787741608'
    },
    'pulse-06': {
      'Two-Tone / Black': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/bbFdQHFsVkrjGUJh.png?v=1787948407',
      'Gold / Champagne': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/BnJsJaMpPtmDlfJE.png?v=1787770505',
      'Rose / Black': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/DXBVifYfWwjhjWxu.png?v=1787741608',
      'Rose / Brown': 'https://cdn.shopify.com/s/files/1/0804/4943/7895/files/fXwgMqOSyqszxuRB.png?v=1787741608'
    }
  }
};
